var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow"},[_c('ol',[_c('li',{class:{active: _vm.Selected === 'organize'}},[_vm._v(_vm._s(_vm.$language.LabelPlanningStep1))]),_c('li',{class:{active: _vm.Selected === 'flowDiagram'}},[_vm._v(_vm._s(_vm.$language.LabelPlanningStep2))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }